<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item label="手机号: " style="margin-left: 20px">
        <el-input v-model="selectForm.phone" placeholder="请输入手机号" style="width: 250px" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectAll">搜索</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" @click="ejectaddGoods">新增商品</el-button>
      </el-form-item> -->
    </el-form>
    <!-- 商品表格 -->
    <el-table border :data="goodsArr" style="width: 100%; overflow-y: scroll" height="calc(100vh - 220px)"
      v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="正在加载中">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="用户openid" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.openid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户手机号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="交易金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? '+' : '-' }} {{ scope.row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="余额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="100" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="ejectupdataGoods(scope.row)"
            >修改</el-button
          >
          <el-button size="mini" type="danger" @click="deleteGoods(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 产品提交表单 -->
    <el-dialog :title="inpitTypeName" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.phone" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="是否为会员: " :label-width="formLabelWidth" required>
          <el-select v-model="form.is_vip" placeholder="请选择" style="width: 100%">
            <div v-for="item in isVipList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import {
  selectMoneyMiniRecord,
} from "@/services/marketing/moneyRecord";
import { IP } from "@/services/index.js";

// import { addSku, selectSku, deleteSku } from "@/services/sku";
export default {
  created() {
    this.selectAll();
  },

  data() {
    return {
      selectForm: {},
      status: 0,
      statusArr: [
        { id: 0, name: "否" },
        { id: 1, name: "是" },
      ],
      goodsTitle: "",
      tableData: [],
      categoryId: "",
      productName: "",
      // 一级分类 二级分类 商品
      select_one_id: "",
      isVipList: [
        {
          id: 0,
          name: "否",
        },
        {
          id: 1,
          name: "是",
        },
      ],
      nextCategoryArr: [],
      goodsArr: [],
      dialogFormVisible: false, 
      dialogImgVisible: false, //产品图维护
   
      imgEditVisible: false,
      imgObj: {},
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: true,
      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      skuForm: {
        //新增sku
        productId: "",
        price: "",
        sku: "",
      },
      skuVisible: false,
    };
  },
  methods: {
    selectAll() {
      selectMoneyMiniRecord({
        ...this.selectForm,
        phone: this.selectForm.phone ? this.selectForm.phone : "1",
        salePhone: this.selectForm.salePhone ? this.selectForm.salePhone : "1",
      }).then((resp) => {

        this.loading = false;
        this.goodsArr = resp.data;

      });
    },
    // 根据分类id查二级分类
    selecCategoryBtn(e) {
      this.selectAll();
    },

    coverImgBtn(e) {
      this.form.coverImg = e.data;
    },
    /* 编辑图片 */
    updateImgBtn(e) {
      this.fileList = [];
      this.imgObj.imgUrl = e.data;
    },

    /*  移除上传的内容 */
    handleRemove(e, fileList) {
      console.log("移除---------------", e, fileList);
    },

    ejectupdataGoods(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改用户信息";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },

    ejectaddGoods() {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增商品";
      this.form = {};
      this.select_one_id = "";
      this.fileList = [];
    },

    ejectupdataImgs(row) {
      this.dialogImgVisible = true;
      this.inpitTypeName = "商品图片维护";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      //查询
      this.handleSeletImg();
      this.handleSeletDeatilImg();
    },

    /* 编辑图片弹窗 */
    handleEditImg(row) {
      this.fileList = [];
      this.imgEditVisible = true;
      this.imgObj = JSON.parse(JSON.stringify(row));
    },

    /* 提交商品详情按钮 */
    updataBtn() {
      if (this.form.is_vip !== 0 && this.form.is_vip !== 1) {
        this.$message.error("请选择");
        return;
      }
      if (this.inpitTypeName == "修改用户信息") {
        // updateUser(this.form).then((resp) => {

        //   if (resp.code == 200) {
        //     this.$message.success("修改成功");
        //     this.dialogFormVisible = false;
        //     this.selectAll();
        //   } else {
        //     this.$message.error("修改失败");
        //   }
        // });
      }
    },

    /* 删除商品 */
    deleteGoods(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          // deleteUser(row.id).then((resp) => {

          //   this.$message({
          //     type: "success",
          //     message: "删除成功!",
          //   });
          //   this.selectAll();
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}

.demo-form-inline {
  margin: 20px 0 0;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.goodsTitle:hover {
  cursor: pointer;
}

.upload-demo {
  margin: 20px;
}

.imgUrlBox,
.detailsImgBox {
  width: 100%;
}

.imgUrlBox {
  margin-bottom: 80px;
}

.imgUrlBoxShow {
  display: flex;
}

.imgUrlBoxShow>div {
  margin: 10px;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border: 1px dotted rgb(93, 93, 93);
}

.imgUrlBoxShow>div:hover {
  cursor: pointer;
}

.detailsImgBoxShow>div {
  border: 1px dotted rgb(93, 93, 93);
  margin: 0 auto;
}

.detailsImgBoxShow>div:hover {
  cursor: pointer;
}

.detailsImgBoxShow>div img {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
